import {equipmentOidTypes} from '@/components/mixins/ConversionMixin'

export default class VelhoGateModel {
    // Private properties
    /** @type {string} */
    _external_system_id = equipmentOidTypes.EXTERNAL_GATES

    constructor(
        condition = null, material = null, code = "", width = null, height = null, openingMechanism = null, position = { x: null, y: null },
        roadNum = null, roadSec = null, distance = null, equipmentDamages = [], locationDeviation = null,
        locationSpecification = { lane: [], side: null, tracks: null, central_area: null }, externalSystemId = ""
    ) {
        /** @type {number | null} */
        this.condition = condition

        /** @type {number | null} */
        this.material = material

        /** @type {string} */
        this.code = code

        /** @type {number | null} */
        this.width = width

        /** @type {number | null} */
        this.height = height

        /** @type {number | null} */
        this.opening_mechanism = openingMechanism

        /** @type {{ x: number, y: number }} */
        this.position = position

        /** @type {number | null} */
        this.road_num = roadNum

        /** @type {number | null} */
        this.road_sec = roadSec

        /** @type {number | null} */
        this.distance = distance

        /** @type {Array} */
        this.equipment_damages = equipmentDamages

        /** @type {number | null} */
        this.location_deviation = locationDeviation

        /** @type {{ lane: number[], side: number | null, tracks: number | null, central_area: number | null }} */
        this.location_specification = locationSpecification

        if(externalSystemId) {
            this._external_system_id = externalSystemId
        }
    }

    /**
    * Gets the unique identifier.
    * @returns {string}
    */
    get external_system_id() {
        return this._external_system_id
    }

    /**
    * Get the json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(JSON.stringify({
            external_system_id: this._external_system_id,
            condition: this.condition,
            material: this.material,
            code: this.code,
            width: this.width,
            height: this.height,
            opening_mechanism: this.opening_mechanism,
            position: this.position,
            road_num: this.road_num,
            road_sec: this.road_sec,
            distance: this.distance,
            equipment_damages: this.equipment_damages,
            location_deviation: this.location_deviation,
            location_specification: {
                ...this.location_specification,
                tracks: this.location_specification.tracks !== null ? [this.location_specification.tracks] : []
            }
        }))
    }

    /**
    * Create default Velho gate instance with position data.
    * @param {{ x: number, y: number }} position - coordinates.
    * @param {number | null} roadNum - Road number.
    * @param {number | null} roadSec - road section.
    * @param {number | null} distance - distance (road geometry).
    * @returns {VelhoGateModel} A new Velho gate instance.
    */
    static instanceWithPosition(position, roadNum, roadSec, distance) {
        const instance = new VelhoGateModel()
        instance.position = position
        instance.road_num = roadNum
        instance.road_sec = roadSec
        instance.distance = distance
        return instance
    }
}
